export const takeAdsName = 'takeAds';
